import { immerable } from "immer";
import { RunningProcessStatus } from "avvir";

import addDateGetterAndSetterToDomainModel from "../../services/utilities/mixins/add_date_getter_and_setter_to_domain_model";
import addReadOnlyPropertiesToModel from "../../services/utilities/mixins/add_read_only_properties_to_model";
import ProcessStatus from "./enums/process_status";

import type { DateLike, ModifyPartial } from "type_aliases";
import { isRunningProcessStatus } from "../../services/utilities/custom_type_guards";

export type RunningProcessArgument = ModifyPartial<RunningProcess, {
  startDate?: DateLike
  endDate?: DateLike
  status: ProcessStatus | RunningProcessStatus
}>

export class RunningProcess {
  constructor({ id, name, status, startDate, endDate, updates }: RunningProcessArgument = {}) {
    addReadOnlyPropertiesToModel(this, { id });
    this.name = name || null;
    if (isRunningProcessStatus(status)) {
      if (status === RunningProcessStatus.RUNNING) {
        this.status = ProcessStatus.RUNNING;
      } else if (status === RunningProcessStatus.COMPLETED) {
        this.status = ProcessStatus.SUCCEEDED;
      } else {
        this.status = ProcessStatus.FAILED;
      }
    } else {
      this.status = status || null;
    }
    addDateGetterAndSetterToDomainModel(this, "startDate", startDate);
    addDateGetterAndSetterToDomainModel(this, "endDate", endDate);
    this.updates = updates || 0;
  }

  readonly id: number;
  name: string;
  status: ProcessStatus;
  readonly startDate: Date;
  endDate: Date;
  updates: number;

  static readonly [immerable] = true;
}

export default RunningProcess;
